import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { ExternalLink } from "@components/atoms/ExternalLink/ExternalLink";

const reportItCookieDefault = "westminster-city-council_cookiecontrol-version";
const reportItCookieDefaultContent = "1.0.0";
const reportItCookie = "westminster-city-council_cookiecontrol";
const reportItCookieContent = "2";

/**
 * Cookie component
 *
 * @category Cookies
 * @props
 */

type WestminsterCityCouncilCookie =
  | "westminster-city-council_cookiecontrol-version"
  | "westminster-city-council_cookiecontrol";

export const CookieBanner: React.FunctionComponent = () => {
  const [showCookieBanner, setshowCookieBanner] = useState<string>("");
  const [cookies, setCookie] = useCookies<WestminsterCityCouncilCookie>([
    "westminster-city-council_cookiecontrol-version",
  ]);

  const hideCookieBanner = () => {
    setCookie(reportItCookie, reportItCookieContent, { path: "/" });
    setCookie(reportItCookieDefault, reportItCookieDefaultContent, {
      path: "/",
    });
    setshowCookieBanner("");
  };
  const removeCookieClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setCookie(reportItCookieDefault, reportItCookieDefaultContent, {
      path: "/",
    });
    setshowCookieBanner("");
  };

  useEffect(() => {
    if (cookies[reportItCookieDefault] !== reportItCookieDefaultContent) {
      setshowCookieBanner("show");
    }
  }, [cookies, setCookie]);

  return (
    <div className={"alert cookiealert " + showCookieBanner} role="alert">
      <div className="row p-6">
        <div className="col text-left">
          <div>
            <span className="header-4 text-white">
              We use cookies on this site to enhance your user experience
            </span>
            <p>By clicking the Accept button, you agree to us doing so.</p>
            <div>
              <ExternalLink
                href="https://www.westminster.gov.uk/data-protection/privacy"
                newTab={true}
              >
                More info on our cookie policy
              </ExternalLink>
            </div>
          </div>
        </div>
        <div className="col ml-auto text-right">
          <div className="text-center">
            <button
              type="button"
              className="primary-button bg-button-default"
              onClick={hideCookieBanner}
            >
              Accept cookies policy
            </button>
            <div className="mt-3">
              <Link to="" onClick={removeCookieClick}>
                Decline cookies policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
